export const getTenant = () => {
  const subdomain = localStorage.getItem('subdomain') || '';
  if (subdomain && !/^[a-zA-Z0-9_-]+$/.test(subdomain)) {
    localStorage.removeItem('subdomain');
    window.location.href = '/login';
    return '';
  }
  return subdomain;
};

export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://example.com/';

// Media is served from the Huawei OBS bucket in staging/prod. Override per
// environment via VUE_APP_IMG_BASE_URL in .env (e.g. the public OBS URL with a
// trailing slash). Falls back to <API_BASE_URL>/storage/ for local dev where
// uploads are served from Laravel's public disk on the same host.
export const IMG_BASE_URL =
  process.env.VUE_APP_IMG_BASE_URL ||
  (process.env.VUE_APP_API_BASE_URL || '') + 'storage/';
export const SUPER_ADMIN_PREFIX = 'super-admin/';

export const LANGUAGES = [
  {
    flag: require('@/assets/images/flags/en.svg'),
    language: 'en',
    title: 'English',
    dir: 'ltr',
  },
  {
    flag: require('@/assets/images/flags/ar.svg'),
    language: 'ar',
    title: 'العربية',
    dir: 'rtl',
  },
];

const I18N_LOCALE = localStorage.getItem('I18N_LOCALE') || process.env.VUE_APP_I18N_LOCALE;
const langIndex = LANGUAGES.findIndex((item) => item.language == I18N_LOCALE);
export const LANGUAGE = LANGUAGES[langIndex > -1 ? langIndex : 0];
// export const LANGUAGE = LANGUAGES[langIndex > -1 ? 1 : 1];
export const FALLBACK_LOCALE = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en';

export const PER_PAGE = 20;
export const DROPDOWN_LIMIT = 1000;
export const PROJECT_NAME = 'Fahsy';
